/*
 *
 * RTM resolver constants
 *
 */

// API layer constants for assets

export const RTM_LEARNER_ASSET_GET = 'learner.asset.get';
export const RTM_LEARNER_ASSET_GET_OK = 'learner.asset.get.ok';
export const RTM_LEARNER_ASSET_GET_ERROR = 'learner.asset.get.error';
